import { GOOGLE_SHEETS_WEBHOOK_URL } from "./contactService";

export const partnerService = {
  /**
   * Submit partnership inquiry lead directly to Google Sheets from frontend.
   * @param {Object} form - { name, email, organization, role, interest, message }
   */
  async submitLead(form) {
    const submission = {
      name: form.name,
      email: form.email,
      phone: form.phone || form.organization || "N/A",
      subject: `Partnership: ${form.interest || "General"}`,
      role: form.role || "Partner",
      message: `[Org: ${form.organization || "N/A"}] ${form.message}`,
      submitted_at: new Date().toISOString(),
    };

    if (GOOGLE_SHEETS_WEBHOOK_URL) {
      try {
        await fetch(GOOGLE_SHEETS_WEBHOOK_URL, {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
          body: JSON.stringify(submission),
        });
      } catch (err) {
        console.warn("Google Sheets partner submission notice:", err);
      }
    }

    return { success: true, data: submission };
  },
};

export default partnerService;
